export default function handleImportSuccess(context, response) {
  if (!response || !response.success) return false;

  context.$message.success(response.message || '导入任务已创建，正在后台处理');
  return true;
}
